import React from "react";
import { CardContent } from "@bmi-digital/components/card";
import { microCopy } from "@bmi-digital/dxb-microcopies";
import {
  MapInfoOverlayContainer,
  MapInfoOverlayCard,
  MapInfoOverlayHeader,
  MapInfoOverlayTitle,
  MapInfoOverlayDescription,
  MapInfoOverlayCloseButton
} from "../styles/styles";
import { useSiteContext } from "../../Site";

export type MapInfoOverlayProps = {
  onClose: () => void;
  title: string;
  description?: string | null;
};

export const MapInfoOverlay = ({
  onClose,
  title,
  description
}: MapInfoOverlayProps) => {
  const { getMicroCopy } = useSiteContext();
  const closeLabel = getMicroCopy(microCopy.GLOBAL_CLOSE);

  return (
    <MapInfoOverlayContainer>
      <MapInfoOverlayCard>
        <CardContent>
          <MapInfoOverlayHeader>
            <MapInfoOverlayTitle variant="h4" hasUnderline={!!description}>
              {title}
            </MapInfoOverlayTitle>
            <MapInfoOverlayCloseButton
              accessibilityLabel={closeLabel}
              gtm={{
                id: "cta-click1",
                label: closeLabel
              }}
              onClick={onClose}
            />
          </MapInfoOverlayHeader>
          {description && (
            <MapInfoOverlayDescription>{description}</MapInfoOverlayDescription>
          )}
        </CardContent>
      </MapInfoOverlayCard>
    </MapInfoOverlayContainer>
  );
};
